import { defineStore } from "pinia";
import { reactive } from "vue";
import { useFirestore, getCurrentUser } from "vuefire";
import { collection, doc, setDoc, getDoc } from "firebase/firestore";
export const useUserStore = defineStore("user", () => {
  const db = useFirestore();

  const basic = reactive({
    uid: "",
    fName: "",
    lName: "",
    examDate: "",
    email: "",
    onboarded: false,
    subscriptions: {},
    flaggedInterviewBankStations: [],
    flaggedVideoBankStations: [],
    flashcardsConfig: null,
  });

  const extra = reactive({
    // These will only be populated on-demand when needed using getExtraUserData()
    number: "",
    year: "",
    hospital: "",
    hear: "",
  });

  const createUserInFirestore = async (uid) => {
    await setDoc(
      doc(collection(db, "users"), uid),
      {
        basic: {
          fName: "",
          lName: "",
          examDate: "",
          onboarded: false, // since they are a new user
        },
      },
      { merge: true },
    );
  };
  const updateExamDate = async (newDate) => {
    // Convert string date to Firebase timestamp
    const dateObj = new Date(newDate);

    await setDoc(
      doc(collection(db, "users"), basic.uid),
      {
        basic: {
          examDate: dateObj,
        },
      },
      { merge: true },
    );
  };

  const onboardUser = async (details) => {
    const user = await getCurrentUser();
    if (!user) return;
    await setDoc(
      doc(collection(db, "users"), user.uid),
      {
        basic: {
          fName: details.firstName,
          lName: details.lastName,
          examDate: details.examDate ? new Date(details.examDate) : "",
          onboarded: true, // since they have been onboarded
        },
        extra: {
          year: details.year,
          hospital: details.hospital,
          hear: details.hear,
        },
        stats: {
          questionsAttempted: 0,
          questionsCorrect: 0,
          uniqueQuestionsAttempted: 0,
          categories: {},
          questions: {},
        },
        part1Stats: {
          questionsAttempted: 0,
          questionsCorrect: 0,
          uniqueQuestionsAttempted: 0,
          categories: {},
          questions: {},
        },
        dukeElderStats: {
          questionsAttempted: 0,
          questionsCorrect: 0,
          uniqueQuestionsAttempted: 0,
          categories: {},
          questions: {},
        },
      },
      { merge: true },
    );
    await getBasicUserData();
  };

  const getBasicUserData = async () => {
    const user = await getCurrentUser();
    if (!user) return;
    const userDoc = doc(collection(db, "users"), user.uid);
    const docSnap = await getDoc(userDoc);

    if (!docSnap.exists()) {
      // means they just signed up
      // need to add basic info to db
      await createUserInFirestore(user.uid);
    } else {
      const data = docSnap.data();
      basic.uid = user.uid;
      basic.fName = data.basic.fName;
      basic.lName = data.basic.lName;
      basic.examDate = data.basic.examDate;
      basic.onboarded = data.basic.onboarded;
      basic.email = user.email;
      basic.subscriptions = data.subscriptions;
      basic.flaggedInterviewBankStations =
        data?.flaggedInterviewBankStations || [];
      basic.flaggedVideoBankStations = data?.flaggedVideoBankStations || [];
      basic.flashcardsConfig = data.flashcardsConfig || null;
    }
  };

  return {
    basic,
    extra,
    onboardUser,
    getBasicUserData,
    createUserInFirestore,
    updateExamDate,
  };
});
